import ShoppingCartSummary from './ShoppingCartSummary';
export default ShoppingCartSummary;
